import { render } from "./detailTableAntrian.vue?vue&type=template&id=29a2cfb4"
import script from "./detailTableAntrian.vue?vue&type=script&lang=js"
export * from "./detailTableAntrian.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__